/**
 * Hand-written mirror of the waba onboarding journal DTOs (see
 * waba/src/main/java/.../domain/model/{OnboardingEvent,OnboardingJourney,OnboardingStepCatalog}.java).
 *
 * Not generated by ng-openapi-gen for the same reason as announcement.models.ts: the checked-in
 * swagger is only refreshed from a live server, and these endpoints are not deployed yet.
 */

export type OnboardingPhase =
  | "META_SIGNUP"
  | "META_PROVISIONING"
  | "SETUP_CHECKLIST"
  | "GUIDE_TOUR";

export type OnboardingEventStatus =
  | "STARTED"
  | "SUCCESS"
  | "FAILED"
  | "SKIPPED"
  | "CANCELLED";

export type OnboardingEventSource = "WEB" | "BACKEND" | "META_WEBHOOK";

export interface OnboardingEvent {
  id?: number;
  reference?: string;
  createdAt?: string;
  companyId?: string;
  phase?: OnboardingPhase;
  step?: string;
  status?: OnboardingEventStatus;
  source?: OnboardingEventSource;
  label?: string;
  errorMessage?: string;
  /** Free-form JSON string — identifiers and Meta's own wording, never a token. */
  detailJson?: string;
  userName?: string;
  requestId?: string;
  durationMs?: number;
  occurredAt?: string;
}

export interface OnboardingJourneyStep {
  step: string;
  phase?: OnboardingPhase;
  /** Counts toward completionPercent; optional steps are informational only. */
  required: boolean;
  /** Absent when the company never reached this step. */
  status?: OnboardingEventStatus;
  label?: string;
  errorMessage?: string;
  lastOccurredAt?: string;
  attempts: number;
}

export interface OnboardingJourney {
  companyId?: string;
  companyReference?: string;
  companyName?: string;
  steps?: OnboardingJourneyStep[];
  events?: OnboardingEvent[];
  totalEvents?: number;
  failedEvents?: number;
  requiredStepsTotal?: number;
  requiredStepsDone?: number;
  completionPercent?: number;
  completed?: boolean;
  /** At least one required step is currently failing — the customer is stuck. */
  blocked?: boolean;
  firstEventAt?: string;
  lastEventAt?: string;
}

/** Steps the back office knows how to label; mirrors OnboardingStepCatalog. */
export const ONBOARDING_STEP_LABEL_KEYS: Record<string, string> = {
  META_SIGNUP_LAUNCHED: "COMPANY.ONBOARDING.STEP.SIGNUP_LAUNCHED",
  META_SIGNUP_FINISHED: "COMPANY.ONBOARDING.STEP.SIGNUP_FINISHED",
  META_EXCHANGE_TOKEN: "COMPANY.ONBOARDING.STEP.EXCHANGE_TOKEN",
  META_RESOLVE_PHONE: "COMPANY.ONBOARDING.STEP.RESOLVE_PHONE",
  META_COEXISTENCE_CHECK: "COMPANY.ONBOARDING.STEP.COEXISTENCE_CHECK",
  META_CONFIG_SAVED: "COMPANY.ONBOARDING.STEP.CONFIG_SAVED",
  META_PHONE_REGISTRATION: "COMPANY.ONBOARDING.STEP.PHONE_REGISTRATION",
  META_WEBHOOK_SUBSCRIPTION: "COMPANY.ONBOARDING.STEP.WEBHOOK_SUBSCRIPTION",
};

export const ONBOARDING_STEPS = {
  signupLaunched: "META_SIGNUP_LAUNCHED",
  signupFinished: "META_SIGNUP_FINISHED",
  setupStepPrefix: "SETUP_STEP_",
  tourPrefix: "TOUR_",
} as const;
